// @flow
import Cookies from 'js-cookie';

export default class LoginHandler {
  static loginProps: {
    username?: string,
    userUrl?: string,
    loginUrl?: string,
    logoutUrl?: string,
    cookieName?: string,
  } = {};

  static getLoginState(cookieName?: string = 'loginStateFe'): string | void {
    return Cookies.get(cookieName);
  }

  static getLoginStateAsBoolean(cookieName?: string = 'loginStateFe'): boolean {
    const state = this.getLoginState(cookieName);
    return !!(state && state !== 'false');
  }

  static setLoginState(config: {
    value?: string,
    cookieName?: string,
    expires?: number,
  }): void {
    const { value, cookieName, expires = 1 } = config || {};
    const name = !cookieName ? 'loginStateFe' : cookieName;
    if (!value) {
      Cookies.remove(name);
    } else {
      Cookies.set(name, value, { expires });
    }
  }

  /**
   * Get login/logout/user URL and username from DOM Nodes
   * default selectors:
   * - loginSelector: '.typo3fe-login'
   * - logoutSelector: '.typo3fe-logout'
   * - userSelector: '.typo3fe-user'
   * There is a data-cookie-name attribute on the login node, which is used to set the cookie name if you do not want to use the default 'loginStateFe'.
   * Dom structure should be like this:
   * <div class="typo3fe-login" data-cookie-name="loginStateFe">
   *   <a href="/login">Login</a>
   * </div>
   */
  static getLoginPropsFromDom(config?: {
    loginSelector?: string,
    logoutSelector?: string,
    userSelector?: string,
  }): {
    username?: string,
    userUrl?: string,
    loginUrl?: string,
    logoutUrl?: string,
    cookieName?: string,
  } {
    const $loginNode = document.querySelector(
      config?.loginSelector || '.typo3fe-login'
    );
    const $logoutNode = document.querySelector(
      config?.logoutSelector || '.typo3fe-logout'
    );
    const $userNode = document.querySelector(
      config?.userSelector || '.typo3fe-user'
    );
    const loginCookieName =
      $loginNode?.getAttribute('data-cookie-name') || undefined;

    const loginState = {
      username: $userNode?.querySelector('a')?.textContent,
      userUrl: $userNode?.querySelector('a')?.href,
      loginUrl: $loginNode?.querySelector('a')?.href,
      logoutUrl: $logoutNode?.querySelector('a')?.href,
      cookieName: loginCookieName,
    };
    if (!window.LoginHandler) {
      window.LoginHandler = LoginHandler;
    }
    window.LoginHandler.loginProps = loginState;
    return loginState;
  }

  static getLoginStateFromWindow(): boolean | void {
    const cookieName = window.LoginHandler?.loginProps?.cookieName;
    if (!cookieName) {
      console.warn(
        'No cookie name found in window.LoginHandler.loginProps. Using default loginStateFe.'
      );
    }
    return this.getLoginStateAsBoolean(cookieName);
  }
}

window.LoginHandler = LoginHandler;
